<div class="text-sm font-medium text-center text-body border-b border-default">
  <ul class="flex flex-wrap -mb-px">
    @for (tab of tabs(); track $index) {
      <li class="me-2">
        @if (tab.disabled()) {
          <span class="inline-block p-4 text-fg-disabled rounded-t-base cursor-not-allowed">
            {{ tab.title() }}
          </span>
        } @else {
          <button
            type="button"
            (click)="selectTab($index)"
            [class.active]="isActive($index)"
            [class.text-brand]="isActive($index)"
            [class.border-brand!]="isActive($index)"
            class="inline-block p-4 border-b border-transparent cursor-pointer rounded-t-base hover:text-brand hover:border-brand transition-colors focus:outline-brand"
            [attr.aria-current]="isActive($index) ? 'page' : null"
            [id]="tab.id()"
          >
            <span class="hidden sm:inline">{{ tab.title() }}</span>
            <span class="sm:hidden">{{ tab.shortTitle() || tab.title() }}</span>
          </button>
        }
      </li>
    }
  </ul>
</div>

<div class="tab-content-wrapper">
  @for (tab of tabs(); track $index) {
    @let content = tab.content();
    @if (content && tab.hasBeenViewed()) {
      <div [class.opacity-0]="!tab.isActive()"
           [class.opacity-100]="tab.isActive()"
           [class.-translate-x-4]="!tab.isActive() && tab.slideDirection() === 'left'"
           [class.translate-x-4]="!tab.isActive() && tab.slideDirection() === 'right'"
           [class.translate-x-0]="tab.isActive()"
           [style.display]="tab.isActive() ? 'block' : 'none'"
           class="transition-all duration-500 ease-in-out tab-content">
        <ng-container *ngTemplateOutlet="content" />
      </div>
    }
  }

  <ng-content />
</div>

